import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import columns from './Table/columns';

import { useContext } from '../Context';
import Filters from './Table/Filters';

export default function Table({ startEdit }) {
  const { state } = useContext();
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [renewalMethod, setRenewalMethod] = useState(null);
  const [status, setStatus] = useState(null);

  const plans = (state.policy.attributes.plans || [])
    .filter((plan) => (paymentMethod === null || (
      paymentMethod === 'free' ? plan.attributes.is_free : plan.attributes.payment_information_id === paymentMethod
    )) && (renewalMethod === null || plan.attributes.renewal_method === renewalMethod)
      && (status === null || plan.attributes.status === status));

  return (
    <>
      <Filters
        setPaymentMethod={setPaymentMethod}
        setRenewalMethod={setRenewalMethod}
        setStatus={setStatus}
      />
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns(startEdit)}
          data={plans}
          noDataComponent={<div className="mt20">No matching records found</div>}
          persistTableHead
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: 'All',
          }}
        />
      </div>
    </>
  );
}
